<template>
<div>
    <base-header v-once pageName="활동 리포트" :prevBtnShow="true" history="main"></base-header>
    
    <section id="wrap">
        <div class="report-month" v-if="activeTab === 'ave'">
            <button type="button" class="prev" v-if="thisMnFlag === 'Y'" @click="MonthView('N')">이전</button>
            <h6>{{Yr}}년 {{Mn}}월</h6>
            <button type="button" class="next" v-if="thisMnFlag === 'N'" @click="MonthView('Y')">다음</button>
        </div>
        <div class="report-month" v-if="activeTab === 'pre'">
            <h6>{{thisYr}}년 {{thisMn}}월</h6>
        </div>
        <ul class="tab tab-fix">
            <li><button type="button" @click="cusTab('ave')" :class="{ current : activeTab == 'ave'}">평균 대비 분석 결과</button></li>
            <li><button type="button" @click="cusTab('pre')" :class="{ current : activeTab == 'pre'}">전월 대비 분석 결과</button></li>
        </ul>
        
        <div class="reportMon-average" v-show="!view" v-if="thisMnFlag === 'Y'">
            <div class="header">
                <p>
                    <span>나(ME)</span>
                </p>
                <p>
                    <span>실적TOP100</span>
                </p>
            </div>
            <div class="wrap">
                <h6>판매활동</h6>
                <div class="brif">
                    <p>
                        <strong>{{Math.round(crntMonth)}}</strong>
                        <em>%</em>
                    </p>
                    <p>
                        <strong>{{Math.round(avgCrntMonth)}}</strong>
                        <em>%</em>
                    </p>
                </div>
                <div class="data">
                    <ul class="tit me">
                        <li>1구간</li>
                        <li>2구간</li>
                        <li>3구간</li>
                        <li>4구간</li>
                    </ul>
                    <ul class="tit other">
                        <li>1구간</li>
                        <li>2구간</li>
                        <li>3구간</li>
                        <li>4구간</li>
                    </ul>                    
                    <ul class="graph me">
                        <li>{{monRec === undefined ? '0' : monRec.sectSr1}}</li>
                        <li>{{monRec === undefined ? '0' : monRec.sectSr2}}</li>
                        <li>{{monRec === undefined ? '0' : monRec.sectSr3}}</li>
                        <li>{{monRec === undefined ? '0' : monRec.sectSr4}}</li>
                    </ul>
                    <span>소스</span>
                    <ul class="graph other">
                        <li>{{monAvg === undefined ? '0' : monAvg.sectSr1}}</li>
                        <li>{{monAvg === undefined ? '0' : monAvg.sectSr2}}</li>
                        <li>{{monAvg === undefined ? '0' : monAvg.sectSr3}}</li>
                        <li>{{monAvg === undefined ? '0' : monAvg.sectSr4}}</li>
                    </ul>                   
                    <ul class="graph me">
                        <li>{{monRec === undefined ? '0' : monRec.sectDg1}}</li>
                        <li>{{monRec === undefined ? '0' : monRec.sectDg2}}</li>
                        <li>{{monRec === undefined ? '0' : monRec.sectDg3}}</li>
                        <li>{{monRec === undefined ? '0' : monRec.sectDg4}}</li>
                    </ul>
                    <span>진단</span>
                    <ul class="graph other">
                        <li>{{monAvg === undefined ? '0' : monAvg.sectDg1}}</li>
                        <li>{{monAvg === undefined ? '0' : monAvg.sectDg2}}</li>
                        <li>{{monAvg === undefined ? '0' : monAvg.sectDg3}}</li>
                        <li>{{monAvg === undefined ? '0' : monAvg.sectDg4}}</li>
                    </ul>                   
                    <ul class="graph me">
                        <li>{{monRec === undefined ? '0' : monRec.sectCo1}}</li>
                        <li>{{monRec === undefined ? '0' : monRec.sectCo2}}</li>
                        <li>{{monRec === undefined ? '0' : monRec.sectCo3}}</li>
                        <li>{{monRec === undefined ? '0' : monRec.sectCo4}}</li>
                    </ul>
                    <span>상담</span>
                    <ul class="graph other">
                        <li>{{monAvg === undefined ? '0' : monAvg.sectCo1}}</li>
                        <li>{{monAvg === undefined ? '0' : monAvg.sectCo2}}</li>
                        <li>{{monAvg === undefined ? '0' : monAvg.sectCo3}}</li>
                        <li>{{monAvg === undefined ? '0' : monAvg.sectCo4}}</li>
                    </ul>                   
                    <ul class="graph me">
                        <li>{{monRec === undefined ? '0' : monRec.sectKy1}}</li>
                        <li>{{monRec === undefined ? '0' : monRec.sectKy2}}</li>
                        <li>{{monRec === undefined ? '0' : monRec.sectKy3}}</li>
                        <li>{{monRec === undefined ? '0' : monRec.sectKy4}}</li>
                    </ul>
                    <span>계약</span>
                    <ul class="graph other">
                        <li>{{monAvg === undefined ? '0' : monAvg.sectKy1}}</li>
                        <li>{{monAvg === undefined ? '0' : monAvg.sectKy2}}</li>
                        <li>{{monAvg === undefined ? '0' : monAvg.sectKy3}}</li>
                        <li>{{monAvg === undefined ? '0' : monAvg.sectKy4}}</li>
                    </ul>
                </div>
            </div>
            <div class="wrap">
                <h6>관리활동</h6>
                <div class="brif">
                    <p>
                        <strong>{{Math.round(crntMonth2)}}</strong>
                        <em>%</em>
                    </p>
                    <p>
                        <strong>{{Math.round(avgCrntMonth2)}}</strong>
                        <em>%</em>
                    </p>
                </div>
                <div class="data">
                    <ul class="tit me">
                        <li>1구간</li>
                        <li>2구간</li>
                        <li>3구간</li>
                        <li>4구간</li>
                    </ul>
                    <ul class="tit other">
                        <li>1구간</li>
                        <li>2구간</li>
                        <li>3구간</li>
                        <li>4구간</li>
                    </ul>                    
                    <ul class="graph me">
                        <li>{{monRec === undefined ? '0' : monRec.sectAs1}}</li>
                        <li>{{monRec === undefined ? '0' : monRec.sectAs2}}</li>
                        <li>{{monRec === undefined ? '0' : monRec.sectAs3}}</li>
                        <li>{{monRec === undefined ? '0' : monRec.sectAs4}}</li>
                    </ul>
                    <span>A/S</span>
                    <ul class="graph other">
                        <li>{{monAvg === undefined ? '0' : monAvg.sectAs1}}</li>
                        <li>{{monAvg === undefined ? '0' : monAvg.sectAs2}}</li>
                        <li>{{monAvg === undefined ? '0' : monAvg.sectAs3}}</li>
                        <li>{{monAvg === undefined ? '0' : monAvg.sectAs4}}</li>
                    </ul>                   
                    <ul class="graph me">
                        <li>{{monRec === undefined ? '0' : monRec.sectBk1}}</li>
                        <li>{{monRec === undefined ? '0' : monRec.sectBk2}}</li>
                        <li>{{monRec === undefined ? '0' : monRec.sectBk3}}</li>
                        <li>{{monRec === undefined ? '0' : monRec.sectBk4}}</li>
                    </ul>
                    <span>북케어</span>
                    <ul class="graph other">
                        <li>{{monAvg === undefined ? '0' : monAvg.sectBk1}}</li>
                        <li>{{monAvg === undefined ? '0' : monAvg.sectBk2}}</li>
                        <li>{{monAvg === undefined ? '0' : monAvg.sectBk3}}</li>
                        <li>{{monAvg === undefined ? '0' : monAvg.sectBk4}}</li>
                    </ul>                   
                    <ul class="graph me">
                        <li>{{monRec === undefined ? '0' : monRec.sectEd1}}</li>
                        <li>{{monRec === undefined ? '0' : monRec.sectEd2}}</li>
                        <li>{{monRec === undefined ? '0' : monRec.sectEd3}}</li>
                        <li>{{monRec === undefined ? '0' : monRec.sectEd4}}</li>
                    </ul>
                    <span>교육</span>
                    <ul class="graph other">
                        <li>{{monAvg === undefined ? '0' : monAvg.sectEd1}}</li>
                        <li>{{monAvg === undefined ? '0' : monAvg.sectEd2}}</li>
                        <li>{{monAvg === undefined ? '0' : monAvg.sectEd3}}</li>
                        <li>{{monAvg === undefined ? '0' : monAvg.sectEd4}}</li>
                    </ul> 
                </div>
            </div>
        </div>

         <div class="reportMon-average" v-show="!view" v-if="thisMnFlag === 'N'">
            <div class="header">
                <p>
                    <span>나(ME)</span>
                </p>
                <em></em>
                <p>
                    <span>실적TOP100</span>
                </p>
            </div>
            <div class="wrap">
                <h6>판매활동</h6>
                <div class="brif">
                    <p>
                        <strong>{{Math.round(prevMonth)}}</strong>
                        <em>%</em>
                    </p>
                    <p>
                        <strong>{{Math.round(avgPreMonth)}}</strong>
                        <em>%</em>
                    </p>
                </div>
                <div class="data">
                    <ul class="tit me">
                        <li>1구간</li>
                        <li>2구간</li>
                        <li>3구간</li>
                        <li>4구간</li>
                    </ul>
                    <ul class="tit other">
                        <li>1구간</li>
                        <li>2구간</li>
                        <li>3구간</li>
                        <li>4구간</li>
                    </ul>                    
                    <ul class="graph me">
                        <li>{{preRec === undefined ? '0' : preRec.sectSr1}}</li>
                        <li>{{preRec === undefined ? '0' : preRec.sectSr2}}</li>
                        <li>{{preRec === undefined ? '0' : preRec.sectSr3}}</li>
                        <li>{{preRec === undefined ? '0' : preRec.sectSr4}}</li>
                    </ul>
                    <span>소스</span>
                    <ul class="graph other">
                        <li>{{preAvg === undefined ? '0' : preAvg.sectSr1}}</li>
                        <li>{{preAvg === undefined ? '0' : preAvg.sectSr2}}</li>
                        <li>{{preAvg === undefined ? '0' : preAvg.sectSr3}}</li>
                        <li>{{preAvg === undefined ? '0' : preAvg.sectSr4}}</li>
                    </ul>                   
                    <ul class="graph me">
                        <li>{{preRec === undefined ? '0' : preRec.sectDg1}}</li>
                        <li>{{preRec === undefined ? '0' : preRec.sectDg2}}</li>
                        <li>{{preRec === undefined ? '0' : preRec.sectDg3}}</li>
                        <li>{{preRec === undefined ? '0' : preRec.sectDg4}}</li>
                    </ul>
                    <span>진단</span>
                    <ul class="graph other">
                        <li>{{preAvg === undefined ? '0' : preAvg.sectDg1}}</li>
                        <li>{{preAvg === undefined ? '0' : preAvg.sectDg2}}</li>
                        <li>{{preAvg === undefined ? '0' : preAvg.sectDg3}}</li>
                        <li>{{preAvg === undefined ? '0' : preAvg.sectDg4}}</li>
                    </ul>                   
                    <ul class="graph me">
                        <li>{{preRec === undefined ? '0' : preRec.sectCo1}}</li>
                        <li>{{preRec === undefined ? '0' : preRec.sectCo2}}</li>
                        <li>{{preRec === undefined ? '0' : preRec.sectCo3}}</li>
                        <li>{{preRec === undefined ? '0' : preRec.sectCo4}}</li>
                    </ul>
                    <span>상담</span>
                    <ul class="graph other">
                        <li>{{preAvg === undefined ? '0' : preAvg.sectCo1}}</li>
                        <li>{{preAvg === undefined ? '0' : preAvg.sectCo2}}</li>
                        <li>{{preAvg === undefined ? '0' : preAvg.sectCo3}}</li>
                        <li>{{preAvg === undefined ? '0' : preAvg.sectCo4}}</li>
                    </ul>                   
                    <ul class="graph me">
                        <li>{{preRec === undefined ? '0' : preRec.sectKy1}}</li>
                        <li>{{preRec === undefined ? '0' : preRec.sectKy2}}</li>
                        <li>{{preRec === undefined ? '0' : preRec.sectKy3}}</li>
                        <li>{{preRec === undefined ? '0' : preRec.sectKy4}}</li>
                    </ul>
                    <span>계약</span>
                    <ul class="graph other">
                        <li>{{preAvg === undefined ? '0' : preAvg.sectKy1}}</li>
                        <li>{{preAvg === undefined ? '0' : preAvg.sectKy2}}</li>
                        <li>{{preAvg === undefined ? '0' : preAvg.sectKy3}}</li>
                        <li>{{preAvg === undefined ? '0' : preAvg.sectKy4}}</li>
                    </ul>
                </div>
            </div>
            <div class="wrap">
                <h6>관리활동</h6>
                <div class="brif">
                    <p>
                        <strong>{{Math.round(prevMonth2)}}</strong>
                        <em>%</em>
                    </p>
                    <p>
                        <strong>{{Math.round(avgPreMonth2)}}</strong>
                        <em>%</em>
                    </p>
                </div>
                <div class="data">
                    <ul class="tit me">
                        <li>1구간</li>
                        <li>2구간</li>
                        <li>3구간</li>
                        <li>4구간</li>
                    </ul>
                    <ul class="tit other">
                        <li>1구간</li>
                        <li>2구간</li>
                        <li>3구간</li>
                        <li>4구간</li>
                    </ul>                    
                    <ul class="graph me">
                        <li>{{preRec === undefined ? '0' : preRec.sectAs1}}</li>
                        <li>{{preRec === undefined ? '0' : preRec.sectAs2}}</li>
                        <li>{{preRec === undefined ? '0' : preRec.sectAs3}}</li>
                        <li>{{preRec === undefined ? '0' : preRec.sectAs4}}</li>
                    </ul>
                    <span>A/S</span>
                    <ul class="graph other">
                        <li>{{preAvg === undefined ? '0' : preAvg.sectAs1}}</li>
                        <li>{{preAvg === undefined ? '0' : preAvg.sectAs2}}</li>
                        <li>{{preAvg === undefined ? '0' : preAvg.sectAs3}}</li>
                        <li>{{preAvg === undefined ? '0' : preAvg.sectAs4}}</li>
                    </ul>                   
                    <ul class="graph me">
                        <li>{{preRec === undefined ? '0' : preRec.sectBk1}}</li>
                        <li>{{preRec === undefined ? '0' : preRec.sectBk2}}</li>
                        <li>{{preRec === undefined ? '0' : preRec.sectBk3}}</li>
                        <li>{{preRec === undefined ? '0' : preRec.sectBk4}}</li>
                    </ul>
                    <span>북케어</span>
                    <ul class="graph other">
                        <li>{{preAvg === undefined ? '0' : preAvg.sectBk1}}</li>
                        <li>{{preAvg === undefined ? '0' : preAvg.sectBk2}}</li>
                        <li>{{preAvg === undefined ? '0' : preAvg.sectBk3}}</li>
                        <li>{{preAvg === undefined ? '0' : preAvg.sectBk4}}</li>
                    </ul>                   
                    <ul class="graph me">
                        <li>{{preRec === undefined ? '0' : preRec.sectEd1}}</li>
                        <li>{{preRec === undefined ? '0' : preRec.sectEd2}}</li>
                        <li>{{preRec === undefined ? '0' : preRec.sectEd3}}</li>
                        <li>{{preRec === undefined ? '0' : preRec.sectEd4}}</li>
                    </ul>
                    <span>교육</span>
                    <ul class="graph other">
                        <li>{{preAvg === undefined ? '0' : preAvg.sectEd1}}</li>
                        <li>{{preAvg === undefined ? '0' : preAvg.sectEd2}}</li>
                        <li>{{preAvg === undefined ? '0' : preAvg.sectEd3}}</li>
                        <li>{{preAvg === undefined ? '0' : preAvg.sectEd4}}</li>
                    </ul>
                </div>
                
            </div>
        </div>

        <div class="reportMon-prevMon" v-show="view">
            <div class="wrap">
                <h6>종합1</h6>
                <div class="note">
                    <span class="prev">전월</span>
                    <span class="curr">당월</span>
                </div>

                <dl>
                    <dt>소스</dt>
                    <dd>
                        <p :style="{'width': widthChk(preRec === undefined ? 0 : preRec.srSum)+'%'}"><em v-if="preRec != undefined && preRec.srSum != 0">{{preRec === undefined ? 0 : preRec.srSum}}</em></p>
                        <p :style="{'width': widthChk(monRec === undefined ? 0 : monRec.srSum)+'%'}"><em v-if="monRec != undefined && monRec.srSum != 0">{{monRec === undefined ? 0 : monRec.srSum}}</em></p>
                    </dd>
                    <dt>진단</dt>
                    <dd>
                        <p :style="{'width': widthChk(preRec === undefined ? 0 : preRec.dgSum)+'%'}"><em v-if="preRec != undefined && preRec.dgSum != 0">{{preRec === undefined ? 0 : preRec.dgSum}}</em></p>
                        <p :style="{'width': widthChk(monRec === undefined ? 0 : monRec.dgSum)+'%'}"><em v-if="monRec != undefined && monRec.dgSum != 0">{{monRec === undefined ? 0 : monRec.dgSum}}</em></p>
                        
                    </dd>
                    <dt>상담</dt>
                    <dd>
                        <p :style="{'width': widthChk(preRec === undefined ? 0 : preRec.coSum)+'%'}"><em v-if="preRec != undefined && preRec.coSum != 0">{{preRec === undefined ? 0 : preRec.coSum}}</em></p>
                        <p :style="{'width': widthChk(monRec === undefined ? 0 : monRec.coSum)+'%'}"><em v-if="monRec != undefined && monRec.coSum != 0">{{monRec === undefined ? 0 : monRec.coSum}}</em></p>
                    </dd>
                    <dt>계약</dt>
                    <dd>
                        <p :style="{'width': widthChk(preRec === undefined ? 0 : preRec.kySum)+'%'}"><em v-if="preRec != undefined && preRec.kySum != 0">{{preRec === undefined ? 0 : preRec.kySum}}</em></p>
                        <p :style="{'width': widthChk(monRec === undefined ? 0 : monRec.kySum)+'%'}"><em v-if="monRec != undefined && monRec.kySum != 0">{{monRec === undefined ? 0 : monRec.kySum}}</em></p>
                    </dd>
                    <dt>A/S</dt>
                    <dd>
                        <p :style="{'width': widthChk(preRec === undefined ? 0 : preRec.asSum)+'%'}"><em v-if="preRec != undefined && preRec.asSum != 0">{{preRec === undefined ? 0 : preRec.asSum}}</em></p>
                        <p :style="{'width': widthChk(monRec === undefined ? 0 : monRec.asSum)+'%'}"><em v-if="monRec != undefined && monRec.asSum != 0">{{monRec === undefined ? 0 : monRec.asSum}}</em></p>
                    </dd>
                    <dt>북케어</dt>
                    <dd>
                        <p :style="{'width': widthChk(preRec === undefined ? 0 : preRec.bkSum)+'%'}"><em v-if="preRec != undefined && preRec.bkSum != 0">{{preRec === undefined ? 0 : preRec.bkSum}}</em></p>
                        <p :style="{'width': widthChk(monRec === undefined ? 0 : monRec.bkSum)+'%'}"><em v-if="monRec != undefined && monRec.bkSum != 0">{{monRec === undefined ? 0 : monRec.bkSum}}</em></p>
                    </dd>
                    <dt>교육</dt>
                    <dd>
                        <p :style="{'width': widthChk(preRec === undefined ? 0 : preRec.edSum)+'%'}"><em v-if="preRec != undefined && preRec.edSum != 0">{{preRec === undefined ? 0 : preRec.edSum}}</em></p>
                        <p :style="{'width': widthChk(monRec === undefined ? 0 : monRec.edSum)+'%'}"><em v-if="monRec != undefined && monRec.edSum != 0">{{monRec === undefined ? 0 : monRec.edSum}}</em></p>
                    </dd>
                </dl>
            </div>
            <div class="wrap" style="display:block">
                <h6>종합2</h6>
                <div class="note">
                    <span class="sale">판매</span>
                    <span class="mngt">관리</span>
                </div>

                <div class="circle-chart">
                    <div>
                        <p><em>전월</em> <strong>{{ prev.total }}</strong></p>
                        <div class="chart">
                            <div v-if="prev.sale != 0" class="chart1" :style="{'--value': prevMonth2+'%'}">
                                <span :style="{transform:'translate('+chart.prev.sale.left+'px,'+chart.prev.sale.top+'px)'}">{{ prev.sale }}</span>
                            </div>
                            <div v-if="prev.mngt!= 0" class="chart2" :style="{'--value': prevMonth2+'%'}">
                                <span :style="{transform:'translate('+chart.prev.mngt.left+'px,'+chart.prev.mngt.top+'px)'}">{{ prev.mngt }}</span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <p><em>당월</em> <strong>{{ crnt.total }}</strong></p>
                        <div class="chart">
                            <div v-if="crnt.sale != 0" class="chart1"  :style="{'--value': crntMonth2+'%'}">
                                <span :style="{transform:'translate('+chart.crnt.sale.left+'px,'+chart.crnt.sale.top+'px)'}">{{ crnt.sale }}</span>
                            </div>
                            <div v-if="crnt.mngt != 0" class="chart2"  :style="{'--value': crntMonth2+'%'}">
                                <span :style="{transform:'translate('+chart.crnt.mngt.left+'px,'+chart.crnt.mngt.top+'px)'}">{{ crnt.mngt }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
</template>

<script>
export default {
  data() {
      return{    
        myPoint : 0,
        avgPoint : 0,

        preMyPoint : 0,
        preAvgPoint : 0,

        monRec : '',
        monAvg : '',
        preRec : '',
        preAvg : '',

        thisYr : '',
        thisMn : '',
        preYr : '',
        preMn : '',
        Yr : '',
        Mn : '',
        toDay : '',    
        thisMnFlag : 'Y',
        activeTab: "ave",
        view: false,
        prevMonth: '0', // 임시
        prevMonth2: '0', // 임시
        crntMonth: '0', // 임시
        crntMonth2: '0', // 임시

        avgCrntMonth: '0',
        avgCrntMonth2: '0',
        avgPreMonth: '0',
        avgPreMonth2: '0',

        

        prev:{
            total: '',
            sale: 0,  //추후 API 연결해서 이 부분에 숫자 넣어주면 됨
            mngt: 0,  //추후 API 연결해서 이 부분에 숫자 넣어주면 됨
        },
        crnt:{
            total: '',
            sale: 0,  //추후 API 연결해서 이 부분에 숫자 넣어주면 됨
            mngt: 0,  //추후 API 연결해서 이 부분에 숫자 넣어주면 됨
        },
        chart:{
            prev:{
                sale:{
                    left:'50',
                    top:'50',
                },
                mngt:{
                    left:'50',
                    top:'50',
                }
            },
            crnt:{
                sale:{
                    left:'50',
                    top:'50',
                },
                mngt:{
                    left:'50',
                    top:'50',
                }
            }
        }
      };
  },
  created: function () {

    var thisDate = new Date();

    var thisYear = thisDate.getFullYear()+'';
    var thisMonth = ((thisDate.getMonth() + 1) < 10 ? '0' : '') + (thisDate.getMonth() + 1);
    var preMonth = ((thisDate.getMonth()) < 10 ? '0' : '') + (thisDate.getMonth());
    var today = ("00"+(thisDate.getDate()+1)).slice(-2); // 일 (2자리)

    this.thisYr = thisYear;
    this.thisMn = thisMonth;
    this.Yr = thisYear;
    this.Mn = thisMonth;
    this.preYr =  thisYear;
    this.preMn = preMonth;

    this.toDay = today;


    if (thisDate.getMonth() == 0) {

        //전월이 작년 일 경우
        this.preYr = (thisDate.getFullYear()-1)+'' ;
        this.preMn = ((thisDate.getMonth() +12) < 10 ? '0' : '') + (thisDate.getMonth() +12);
    } 


    var that = this;
    var parameters = {
        thisYrmn : that.thisYr + that.thisMn ,
        preYrmn : that.preYr + that.preMn
    };
    this.$api.mypage
    .activityReport(parameters)
    .then(function(data) {
        
        if(data){

            that.monRec = data.monRec;
            that.monAvg = data.monAvg;
            that.preRec = data.preRec;
            that.preAvg = data.preAvg;

            var monPoint = 0;
            var prePoint = 0;

            if(that.monRec != undefined && that.monAvg != undefined ) {
                if((parseInt(that.monRec.srSum) - parseInt(that.monAvg.srSum)) >= 0) monPoint = monPoint + 1;
                if((parseInt(that.monRec.dgSum) - parseInt(that.monAvg.dgSum)) >= 0) monPoint = monPoint + 1;
                if((parseInt(that.monRec.coSum) - parseInt(that.monAvg.coSum)) >= 0) monPoint = monPoint + 1;
                if((parseInt(that.monRec.kySum) - parseInt(that.monAvg.kySum)) >= 0) monPoint = monPoint + 1;
                if((parseInt(that.monRec.asSum) - parseInt(that.monAvg.asSum)) >= 0) monPoint = monPoint + 1;
                if((parseInt(that.monRec.bkSum) - parseInt(that.monAvg.bkSum)) >= 0) monPoint = monPoint + 1;
                if((parseInt(that.monRec.edSum) - parseInt(that.monAvg.edSum)) >= 0) monPoint = monPoint + 1;
            }
            if(that.preRec != undefined && that.preAvg != undefined ) {
                if((parseInt(that.preRec.srSum) - parseInt(that.preAvg.srSum)) >= 0) prePoint = prePoint + 1;
                if((parseInt(that.preRec.dgSum) - parseInt(that.preAvg.dgSum)) >= 0) prePoint = prePoint + 1;
                if((parseInt(that.preRec.coSum) - parseInt(that.preAvg.coSum)) >= 0) prePoint = prePoint + 1;
                if((parseInt(that.preRec.kySum) - parseInt(that.preAvg.kySum)) >= 0) prePoint = prePoint + 1;
                if((parseInt(that.preRec.asSum) - parseInt(that.preAvg.asSum)) >= 0) prePoint = prePoint + 1;
                if((parseInt(that.preRec.bkSum) - parseInt(that.preAvg.bkSum)) >= 0) prePoint = prePoint + 1;
                if((parseInt(that.preRec.edSum) - parseInt(that.preAvg.edSum)) >= 0) prePoint = prePoint + 1;
            }
            that.myPoint = monPoint;
            that.preMyPoint = prePoint;
                var avgPreSale = 0;
                var avgPreMngt = 0;
                var avgCrntSale = 0;
                var avgCrntMngt = 0;

            if(that.preRec != undefined) {
                that.prev.sale = parseInt(that.preRec.srSum) + parseInt(that.preRec.dgSum) + parseInt(that.preRec.coSum) + parseInt(that.preRec.kySum) ; 
                that.prev.mngt = parseInt(that.preRec.asSum) + parseInt(that.preRec.bkSum) + parseInt(that.preRec.edSum);
            }
            if(that.monRec != undefined) {
                that.crnt.sale = parseInt(that.monRec.srSum) + parseInt(that.monRec.dgSum) + parseInt(that.monRec.coSum) + parseInt(that.monRec.kySum) ; 
                that.crnt.mngt = parseInt(that.monRec.asSum) + parseInt(that.monRec.bkSum) + parseInt(that.monRec.edSum);
            }
            if(that.preAvg != undefined) {
                 avgPreSale = parseInt(that.preAvg.srSum) + parseInt(that.preAvg.dgSum) + parseInt(that.preAvg.coSum) + parseInt(that.preAvg.kySum) ;
                 avgPreMngt = parseInt(that.preAvg.asSum) + parseInt(that.preAvg.bkSum) + parseInt(that.preAvg.edSum);
            }
            if(that.monAvg != undefined) {
                 avgCrntSale = parseInt(that.monAvg.srSum) + parseInt(that.monAvg.dgSum) + parseInt(that.monAvg.coSum) + parseInt(that.monAvg.kySum) ;
                 avgCrntMngt = parseInt(that.monAvg.asSum) + parseInt(that.monAvg.bkSum) + parseInt(that.monAvg.edSum);
            }

            var avgPreTotal = avgPreSale + avgPreMngt;
            var avgCrntTotal = avgCrntSale + avgCrntMngt;

            that.prev.total = that.prev.sale + that.prev.mngt;    

            if(that.prev.total != 0) {  //합계가 0 일시 NaN 발생
                that.prevMonth = Math.round(that.prev.sale/that.prev.total*100); // 전월 판매
                that.prevMonth2 = Math.round(that.prev.mngt/that.prev.total*100); // 전월 관리
            }
            if(avgPreTotal != 0) {  //합계가 0 일시 NaN 발생
                that.avgPreMonth = Math.round(avgPreSale/avgPreTotal*100); // 평균 전월 판매
                that.avgPreMonth2 = Math.round(avgPreMngt/avgPreTotal*100); // 평균 전월 관리
            }

            that.crnt.total = that.crnt.sale + that.crnt.mngt;
            if(that.crnt.total != 0) {  //합계가 0 일시 NaN 발생
                that.crntMonth = Math.round(that.crnt.sale/that.crnt.total*100); // 당월 판매
                that.crntMonth2 = Math.round(that.crnt.mngt/that.crnt.total*100); // 당월 관리
            }  
            if(avgCrntTotal != 0) {     //합계가 0 일시 NaN 발생
                that.avgCrntMonth = Math.round(avgCrntSale/avgCrntTotal*100); // 평균 당월 판매
                that.avgCrntMonth2 = Math.round(avgCrntMngt/avgCrntTotal*100); // 평균 당월 관리
            }  

            var radius = 35;
            var prevSale = 100 - that.prevMonth;
            var prevMngt = 100 - prevSale;
            var prevSaleAng = 90+(360*(prevSale/100)/2);
            var prevMngtAng = 90-(360*(prevMngt/100)/2);
            
            var crntSale = 100 - that.crntMonth;
            var crntMngt = 100 - crntSale;
            var crntSaleAng = 90+(360*(crntSale/100)/2);
            var crntMngtAng = 90-(360*(crntMngt/100)/2);
            
            // 전월            
            that.chart.prev.sale.left   = Math.cos(prevSaleAng*Math.PI/180) * radius
            that.chart.prev.sale.top    = Math.sin(prevSaleAng*Math.PI/180) * radius
            that.chart.prev.mngt.left   = Math.cos(prevMngtAng*Math.PI/180) * radius
            that.chart.prev.mngt.top    = Math.sin(prevMngtAng*Math.PI/180) * radius
            
            // 당월 
            that.chart.crnt.sale.left   = Math.cos(crntSaleAng*Math.PI/180) * radius
            that.chart.crnt.sale.top    = Math.sin(crntSaleAng*Math.PI/180) * radius
            that.chart.crnt.mngt.left   = Math.cos(crntMngtAng*Math.PI/180) * radius
            that.chart.crnt.mngt.top    = Math.sin(crntMngtAng*Math.PI/180) * radius
                
            }
        })
        .catch(function(error) {
            alert(error.rtMsg);
        });

  },
  methods: {
    
    
    widthChk: function(sect) {
        var barSize = sect * 5  ; 
        if(barSize > 100) {
            barSize = 100;
        }
        return barSize;
    },
    MonthView: function(month) {
        this.thisMnFlag = month;     
        if(this.thisMnFlag == 'Y') {
            this.Yr = this.thisYr;
            this.Mn = this.thisMn;
        }
        else {
            this.Yr = this.preYr;
            this.Mn = this.preMn;
        }
    },

    cusTab: function(name) {
        this.activeTab = name;
        if(this.activeTab == 'ave') this.view = false;
        else {
            this.view = true;   
        }     
    },
  }
};
</script>
